import * as types from './types'
import listPharmApi from '../api'

export const actions = {
    async [types.LIST_PHARM_FETCH]({commit}, data = null) {
        commit(types.LIST_PHARM_SET_LOADING, true)
        const response = await listPharmApi.all(data)
        commit(types.LIST_PHARM_OBTAIN, response.data.data)
        commit(types.LIST_PHARM_META, response.data.meta)
        commit(types.LIST_PHARM_SET_LOADING, false)
    },
}
